import { KYMW1103Model } from './../kymw1103.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 受注(コード)リスト取得クラス
 *
 * @export GetEBaseNoService
 * @class GetEBaseNoService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetEBaseNoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1103Model;
  private eBaseNo: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetEBaseNoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        EbaseNo: this.eBaseNo
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetEBaseNoService
   */
  execute(model: KYMW1103Model, ebaseNo: string, successFunc: Function = null): void {
    this.model = model;
    this.eBaseNo = ebaseNo;
    this.successFunc = successFunc;
    this.send('geteBaseNo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetEBaseNoService
   */
  success(data: any): void {
    this.model.seteBaseNoCheckResult(data);
    this.model.kymw1103Component.eventGetEbaseNoSuccess();
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
